import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey || url.includes("YOUR-PROJECT")) {
  // eslint-disable-next-line no-console
  console.warn(
    "[stash] Supabase env vars missing. Copy .env.example to .env and fill in your project credentials.",
  );
}

// Pass a non-empty placeholder when unconfigured so createClient doesn't
// throw at import time (e.g. in tests or before .env is filled). The shell
// is never used for real requests unless isConfigured is true.
export const supabase: SupabaseClient = createClient(
  url && !url.includes("YOUR-PROJECT") ? url : "https://placeholder.supabase.co",
  anonKey && !url?.includes("YOUR-PROJECT") ? anonKey : "placeholder-anon-key",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);

export const isConfigured = Boolean(url && anonKey && !url.includes("YOUR-PROJECT"));
